import React, { useState, useEffect } from "react";
import AdminSideMenu from "../../navbar/AdminSideMenu";
import AdminTopMenu from "../../navbar/AdminTopMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getCountryName } from "../../Utils/Helper";
import {
  bililingAPi,
  getCompanyListAPI,
  getMasterCountryList,
} from "../../../api/api";
import useSelectedDate from "../../../store/UseFilterDateStore";

const CustomerBilling = () => {

  const selctedDateFrom = useSelectedDate((state) => state.selctedDateFrom);
  const selctedDateTo = useSelectedDate((state) => state.selctedDateTo);

  const [error, seterror] = useState({
    errarStatus: false,
    errorMessage: "",
    bgcolor: "",
  });

  var date = new Date();
  var todatdate =
    date.getFullYear() +
    "-" +
    (date.getMonth() + 1) +
    "-" +
    ("0" + date.getDate()).slice(-2);
  const [companyList, setcompanyList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [DateFrom, setDateFrom] = useState(selctedDateFrom);
  const [DateTo, setDateTo] = useState(selctedDateTo);
  const [showDateFrom, setshowDateFrom] = useState(null);
  const [showDateTo, setshowDateTo] = useState(null);
  const [selectedCompany, setselectedCompany] = useState("");
  const [selectedCompanyID, setSelectedCompanyID] = useState("");
  const [billingData, setBillingData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [method, setMethod] = useState("cus_summary_all");
  const [totalConst, setTotalConst] = useState();

  const detailsReport = () => {
    setBillingData([]);
    setIsLoading(true);
    bililingAPi(method, DateFrom, DateTo, selectedCompanyID).then((result) => {
      console.log("result.data.data", result.data.data);
      if (result.data.success === true) {
        seterror({ errarStatus: false });
        createNewObject(result.data.data);
        setIsLoading(false);
      } else {
        seterror({
          errarStatus: true,
          errorMessage: result.data.message,
          bgcolor: "alert alert-danger",
        });
        setIsLoading(false);
      }
    });
  };

  useEffect(() => {
    getMasterCountryList().then((res) => {
      if (res.data.success === true) {
        setCountryList(res.data.data);
      } else {
        setCountryList([]);
      }
    });
  }, []);

  useEffect(() => {
    getCompanyList();
  }, []);

  const getCompanyList = () => {
    getCompanyListAPI().then((res) => {
      //console.log("res", res.data);
      if (res.data.success === true) {
        setcompanyList(res.data.data);
      } else {
        setcompanyList([]);
      }
    });
  };

  const handleDateFrom = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    setDateFrom(dated);
    setshowDateFrom(date);
  };

  const handleDateTo = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    setDateTo(dated);
    setshowDateTo(date);
  };

  const userhandlar = (e) => {
    const select = e.target;
    const desc = select.selectedOptions[0].text;
    if (e.target.value === "all") {
      setMethod("cus_summary_all");
    } else {
      setMethod("cus_summary_companywise");
    }
    setselectedCompany(desc);
    setSelectedCompanyID(e.target.value);
    setTotalConst(0);
    seterror({
      errarStatus: false,
    });
    setBillingData([]);
  };

  const createNewObject = (data) => {
    let overallTotalCost = 0;
    let overallTotalSubmission = 0;

    const result = {};
    // Iterate through the main keys (e.g., "wrd_isim", "sheng_isim", etc.)
    for (const key in data) {
      let mainKeyTotalCost = 0;
      let totalSubmition = 0;
      // Check if the main key has a "totalcost" property
      if (data[key].totalcost) {
        // Add the main key's total cost to the running sum
        mainKeyTotalCost += parseFloat(data[key].totalcost);
      }
      // Iterate through the nested keys (e.g., "1", "61", "62", etc.)
      for (const nestedKey in data[key]) {
        // Check if "totalcost" property exists in the nested object
        if (data[key][nestedKey].totalcost) {
          // Add the total cost to the main key's total cost
          mainKeyTotalCost += parseFloat(data[key][nestedKey].totalcost);
        }
      }

      for (const nestedKey in data[key]) {
        // Check if "totalcost" property exists in the nested object
        if (data[key][nestedKey]) {
          // Add the total cost to the main key's total cost
          overallTotalSubmission +=
            parseFloat(data[key][nestedKey].delivered || 0) +
            parseFloat(data[key][nestedKey].failed || 0) +
            parseFloat(data[key][nestedKey].other || 0);
          totalSubmition +=
            parseFloat(data[key][nestedKey].delivered || 0) +
            parseFloat(data[key][nestedKey].failed || 0) +
            parseFloat(data[key][nestedKey].other || 0);
        }
      }

      // Add the main key and its total cost to the result object
      result[key] = {
        totalcost: mainKeyTotalCost.toFixed(5),
        totalSubmition: totalSubmition,
        other: data[key], // Adjust precision as needed
      };
      // Add the main key's total cost to the overall total cost
      overallTotalCost += mainKeyTotalCost;
    }
    // Add an overall total cost to the result object

    result.overallSubmission = overallTotalSubmission; // Adjust precision as needed
    result.overallTotalCost = overallTotalCost.toFixed(5); // Adjust precision as needed
    console.log("result", result);
    setBillingData(result);
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <AdminSideMenu />
        <div className="layout-page">
          <AdminTopMenu />
          <div className="content-wrapper">
            <div className="container-xxl container-p-y">
              <div className="row">
                <div className="col-xl-12">
                  <div className="card  mb-4">
                    <h5 className="card-header">Customer Billing </h5>

                    <div className="card-body ">
                      <div className="row gy-3">
                        <div className="col-md-3">
                          <label>Company</label>
                          <div className="input-group">
                            <select
                              value={selectedCompanyID}
                              onChange={userhandlar}
                              name="selected-user"
                              className="form-select"
                            >
                              <option value="all">All Company </option>
                              {companyList.map((items, i) => (
                                <option key={i} id="box1" value={items.id}>
                                  {items.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-3 col-6">
                          <label>From Date</label>
                          <div className="">
                            <DatePicker
                              className="form-control btn-block"
                              dateFormat="MM/dd/yyyy"
                              selected={showDateFrom}
                              onChange={handleDateFrom}
                              placeholderText={todatdate}
                              maxDate={new Date()}
                            />
                          </div>
                        </div>
                        <div className="col-md-3 col-6">
                          <label> Date To</label>
                          <div className="input-group">
                            <DatePicker
                              startDate={showDateTo}
                              className="form-control btn-block"
                              dateFormat="MM/dd/yyyy"
                              selected={showDateTo}
                              onChange={handleDateTo}
                              placeholderText={todatdate}
                              minDate={new Date(showDateFrom)}
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          <label>&nbsp;</label>
                          <div className="input-group">
                            {isLoading ? (
                              <button className="btn btn-block btn-primary me-1">
                                <FontAwesomeIcon icon={faSearch} /> Loading...
                              </button>
                            ) : (
                              <button
                                onClick={detailsReport}
                                className="btn btn-block btn-primary me-1"
                              >
                                <FontAwesomeIcon icon={faSearch} /> Search
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-12 col-md-12 order-1">
                  <div className="">
                    {error.errarStatus ? (
                      <div className={error.bgcolor} role="alert">
                        <strong>Alert!</strong> {error.errorMessage}
                      </div>
                    ) : null}

                    {billingData && (
                      <div className="card pb-5">
                        <h5 className="card-header pb-0">
                          Total Cost of{" "}
                          <span className="text-primary ml-1 mr-1">
                            {selectedCompany ? selectedCompany : "All"}
                          </span>
                          Company is{" "}
                          <span className="text-info ml-1 badge badge-info text-white mr-2">
                            {billingData.overallTotalCost}
                          </span>
                          and total Submission is
                          <span className="text-info ml-2 badge badge-info text-white">
                            {billingData.overallSubmission}
                          </span>
                        </h5>

                        <div className="p-4">
                          <div className="accordion">
                            {Object.keys(billingData).map((userName, i) => {
                              if (
                                userName !== "overallTotalCost" &&
                                userName !== "overallSubmission"
                              ) {
                                return (
                                  <div key={i} className="card">
                                    <div
                                      role="button"
                                      data-toggle="collapse"
                                      data-target={`#faq${i}`}
                                      aria-expanded="true"
                                      aria-controls={`#faq${i}`}
                                      className="company-name"
                                      id={`faqhead${i}`}
                                    >
                                      <span className="btn btn-header-link">
                                        <span className="text-info badge badge-dark w-50 text-white ml-2 mr-2">
                                          {userName}
                                        </span>
                                        Total Cost :
                                        <span className="text-info badge badge-info text-white ml-2 mr-2">
                                          {billingData[userName]?.totalcost}
                                        </span>
                                        Total Submission :
                                        <span className="text-info badge badge-success text-white ml-2">
                                          {
                                            billingData[userName]
                                              ?.totalSubmition
                                          }
                                        </span>
                                      </span>
                                    </div>
                                    <div
                                      id={`faq${i}`}
                                      className="collapse"
                                      aria-labelledby={`faqhead${i}`}
                                      data-parent="#faq"
                                    >
                                      <div className="card-body">
                                        {Object.keys(
                                          billingData[userName]?.other
                                        ).map((countryCode) => (
                                          <>
                                            <p className="fw-semibold d-block mb-1">
                                              {getCountryName(
                                                countryList,
                                                countryCode
                                              )}
                                            </p>
                                            <div className="d-flex gap-2">
                                              <small className="d-flex gap-5">
                                                {Object.keys(
                                                  billingData[userName].other[
                                                  countryCode
                                                  ]
                                                ).map((status, i) => (
                                                  <div key={i}>

                                                    {status === "totalcost" ? (
                                                      <p className="text-capitalize text-black">
                                                        Total cost :
                                                        {` ` + parseFloat(billingData[userName]
                                                          .other[countryCode][
                                                          'totalcost'
                                                        ]).toFixed(6)
                                                        }
                                                      </p>
                                                    ) : <p className="text-capitalize">
                                                      <span> {status} </span> :
                                                      {` ` +
                                                        billingData[userName]
                                                          .other[countryCode][
                                                        status
                                                        ]
                                                      }
                                                    </p>}


                                                  </div>
                                                ))}
                                                <p className="text-capitalize text-black">
                                                  Total Submission :
                                                  {parseInt(
                                                    billingData[userName].other[
                                                    countryCode
                                                    ]["delivered"] | 0
                                                  ) +
                                                    parseInt(
                                                      billingData[userName]
                                                        .other[countryCode][
                                                      "other"
                                                      ] || 0
                                                    ) +
                                                    parseInt(
                                                      billingData[userName]
                                                        .other[countryCode][
                                                      "failed"
                                                      ] || 0
                                                    )}
                                                </p>
                                              </small>
                                            </div>
                                          </>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerBilling;
